import React from "react";
import GS from "./GrocerySite/GS";

const App = () => {
  return (
    <>
      <GS />
    </>
  );
};

export default App;
